{
  "version": 1,
  "asset_id": "c5618ce8-20c4-4030-8361-e82a37b5ad4f",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/c5618ce8-20c4-4030-8361-e82a37b5ad4f/mark-192.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/c5618ce8-20c4-4030-8361-e82a37b5ad4f/mark-192.avif",
  "original_filename": "mark-192.avif",
  "size": 5753,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:18:13Z"
}
